import { GET_EXPENSES, ADD_EXPENSE/*, DELETE_EXPENSE*/ } from 'redux/actionTypes';

export default function expenses(state = [], action) {
    switch(action.type) {
        case GET_EXPENSES:
            return [
                ...state,
                ...action.payload
            ];
        case ADD_EXPENSE:
            return [
                action.payload,
                ...state
            ];
        /*
        case DELETE_EXPENSE:
            const deleteIndex = state.findIndex(expense => expense.id === action.payload);
            return [
                ...state.slice(0, deleteIndex),
                ...state.slice(deleteIndex + 1)
            ];
        */
        default:
            return state;
    }
};